/**
 * @author liqiuqi
 * @date 2022 2022/4/24 13:55
 */
import store from "@/store";
import { restUGrayReleaseFeatures } from "@/services/common/basic";
import urlAddressDataProcessing from "@/utils/urlAddressDataProcessing";
import { Message } from "element-ui";
import { CookieKeys, Cookies } from "@/utils/cookieKey";
import { companySpaceCheckNewUser } from "@/services/common/new-user-task-grade";
import { authCheck, getLocalAuths, setUserInfo } from "@/utils/common";
import { AUTH_KEY_MAP } from "@/utils/constants/constants.auth";

async function asyncBasicDataInit() {
  // 是否模拟登录
  const isSimulatedLogin = Cookies.get(CookieKeys.cookie_insert_log) === "1";
  store.commit("basic/updateIsSimulatedLogin", isSimulatedLogin);

  await setUserInfo();

  // 本地权限
  store.commit("basic/updateLocalAuth", getLocalAuths());
  console.log();
  // 灰度权限
  const gray = await restUGrayReleaseFeatures();
  store.commit("basic/updateGrayReleaseFeatures", gray.data);

  // 是否是2.5账号
  let isTwoPointFiveAccount;
  try {
    isTwoPointFiveAccount = await companySpaceCheckNewUser();
  } catch (e) {
    isTwoPointFiveAccount = { data: false };
  }

  store.commit("basic/updateIsTwoPointFiveAccount", isTwoPointFiveAccount.data);

  // 是否是2.8账号
  store.commit("basic/updateIsTwoPointEightAccount", authCheck(AUTH_KEY_MAP.VIP_CENTER_V28));

  // 是否爬虫访问
  const UA = navigator.userAgent;
  const isSpider = UA.toLowerCase().indexOf("spider") !== -1;
  store.commit("basic/updateIsSpider", isSpider);
}

function basicFunctionInit() {
  // 重写 window.open
  window.open = (url) => {
    const form = document.createElement("a");
    form.href = url;
    form.target = "_blank";
    document.body.appendChild(form);
    form.click();
    form.remove();
  };
}

function basicListenersInit() {
  window.addEventListener("online", () => {
    Message.closeAll();
    console.log("online");
  });
  window.addEventListener("offline", () => {
    Message({
      message: "您的网络已断开，请检查网络连接是否正常",
      type: "error",
      duration: 0,
      showClose: true,
    });
    console.log("offline");
  });
}

const systemInit = {
  basicFunctionInit,
  basicListenersInit,
  asyncBasicDataInit,
  urlAddressDataProcessing,
};

export default systemInit;
